var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceiptListP(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke:#020202;stroke-miterlimit:10;stroke-width:2px;}.cls-2{stroke-linecap:square;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reciept_alternatif",
    "data-name": "reciept alternatif"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    y1: 7.5,
    x2: 18,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    y1: 11.5,
    x2: 18,
    y2: 11.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    y1: 15.5,
    x2: 18,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8,
    y1: 7.5,
    x2: 6,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8,
    y1: 11.5,
    x2: 6,
    y2: 11.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 8,
    y1: 15.5,
    x2: 6,
    y2: 15.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4 22.5 6.66 20.5 9.33 22.5 11.99 20.5 14.66 22.5 17.33 20.5 20 22.5 21 21.5 21 1.5 3 1.5 3 21.5 4 22.5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptListP);
export default __webpack_public_path__ + "static/media/receipt-list-p.8804dd3cf500a2af72603a71c65b7084.svg";
export { ForwardRef as ReactComponent };